// extracted by mini-css-extract-plugin
module.exports = {"items":"News_items__2ivcp","card":"News_card__wP4Yy"};